export const getValidDrawerSvgPaths = (fullSvg?: string | null): Set<string> | null => {
  if (!fullSvg) return null;
  const doc = new DOMParser().parseFromString(fullSvg, "image/svg+xml");
  const paths = Array.from(doc.querySelectorAll("path"))
    .map((element) => element.getAttribute("d"))
    .filter((d): d is string => Boolean(d));
  return new Set(paths);
};

export const isAssetPositionStale = (
  svgPath: string | null | undefined,
  validPaths: Set<string> | null,
): boolean => {
  if (!svgPath) return false;
  if (!validPaths) return true;
  return !validPaths.has(svgPath);
};
